import { Dialog } from "ui/dialog";

import { SmsSimulatorPersonaAttributes } from "containers/sms-simulator/sms-simulator.types";

import { GRADE_OPTIONS } from "containers/sms-simulator/sms-simulator-personas/components/persona-modal/sms-simulator-personas-form.constants";

const SmsSimulatorViewPersona = ({
  onClose,
  persona,
}: {
  onClose: (isOpen: boolean) => void;
  persona: SmsSimulatorPersonaAttributes;
}) => {
  const fieldDisplayClasses = "w-full h-10 flex items-center rounded-md bg-neutrals-200 border border-zinc-200 px-3 py-1.5 text-base text-neutrals-500 font-normal leading-6";
  return (
    <Dialog
      open
      onClose={() => onClose(false)}
      size="medium"
      headline="Persona Details">
      <div className="flex flex-col gap-4">
        <div className="flex gap-2.5">
          <div className="flex flex-col w-full gap-1.5">
            <div className="text-md font-bold">Name</div>
            <div className={fieldDisplayClasses}>{persona.name}</div>
          </div>
          <div className="flex flex-col w-full gap-1.5">
            <div className="text-md font-bold">Grade</div>
            <div className={fieldDisplayClasses}>
              {GRADE_OPTIONS.find((option) => option.value === persona.grade)?.label ||
                persona.grade}
            </div>
          </div>
        </div>
        <div className="flex flex-col w-full gap-1.5">
          <div className="text-md font-bold">Profile Type</div>
          <div className={fieldDisplayClasses}>{persona.profileType}</div>
        </div>
        <div className="flex flex-col w-full gap-1.5">
          <div className="text-md font-bold">Interests</div>
          <div className="w-full min-h-[5rem] flex rounded-md bg-neutrals-200 border border-zinc-200 px-3 py-1.5 text-base text-neutrals-500 font-normal leading-6 whitespace-pre-wrap">
            {persona.interests}
          </div>
        </div>
      </div>
    </Dialog>
  );
};

export default SmsSimulatorViewPersona;
